import { GroupsPermissionsComponent } from './groups-permissions/groups-permissions.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Route, extract } from '@app/core';
import { AdministrationComponent } from './administration.component';
import { TeacherComponent } from './teacher/teacher.component';
import { SpecialDaysComponent } from './special-days/special-days.component';
import { BasicProcessConfigurationGuard } from './basic-process-configuration/shared/basic-process-configuration.guard';
import { PermissionsGuard } from '@app/core/authentication/permissions.guard';
import {
  BasicProcessConfigurationComponent
} from './basic-process-configuration/basic-process-configuration.component';
import { ManagementSystemComponent } from './management-system/management-system.component';
import { DocumentsComponent } from './documents/documents.component';

const routes: Routes = [
  Route.withShell([
    {
      path: 'administration',
      component: AdministrationComponent,
      canActivate: [PermissionsGuard],
      data: { title: extract('Administration') }
    },
    {
      path: 'administration/master',
      component: TeacherComponent,
      canActivate: [PermissionsGuard],
      data: { title: extract('masterTables') }
    },
    {
      path: 'administration/basic-process-configuration',
      component: BasicProcessConfigurationComponent,
      canActivate: [PermissionsGuard],
      data: { title: extract('basicProcessConfigure') },
      canDeactivate: [BasicProcessConfigurationGuard]
    },
    {
      path: 'administration/special-days',
      component: SpecialDaysComponent,
      canActivate: [PermissionsGuard],
      data: { title: extract('specialDays') }
    },
    {
      path: 'administration/groups-permissions',
      component: GroupsPermissionsComponent,
      canActivate: [PermissionsGuard],
      data: { title: extract('groupsPermissions') }
    },
    {
      path: 'administration/documents',
      component: DocumentsComponent,
      canActivate: [PermissionsGuard],
      data: { title: extract('documents') }
    },
    {
      path: 'administration/system-management',
      component: ManagementSystemComponent,
      canActivate: [PermissionsGuard],
      data: { title: extract('systemManagement') }
    }
  ])
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [BasicProcessConfigurationGuard]
})
export class AdministrationRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/administration/administration-routing.module.ts